import request from '@/utils/request_python'

export function getFlujoCaja(acta_id, start_date, end_date) {
    return request({
      url: `/acta/flujoEjecutado`,
      method: 'get',
      responseType: 'blob',
      params: {
        acta_id: acta_id,
        start_date: start_date,
        end_date: end_date
      }
    })
  }

export function sendFlujoCajaEjecutado(params) {
  return request({
    url: 'acta/save/flujoEjecutado',
    method: 'post',
    params: params
  })
}